/* ═══════════════════════════════════════════════
   SUN POWDER LANDING PAGE — JS
   ═══════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Hero Variant Switching ───────────────── */
  // Default: variant 1. Use ?hero=2 or ?hero=3 in URL to switch.
  const params = new URLSearchParams(window.location.search);
  const heroParam = params.get('hero');
  if (heroParam) {
    const variants = document.querySelectorAll('.hero__variant');
    const target = document.querySelector(`[data-hero="${heroParam}"]`);
    if (target) {
      variants.forEach(v => v.classList.remove('active'));
      target.classList.add('active');
    }
  }

  /* ── Nav Scroll Shadow ────────────────────── */
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('nav--scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ── Reviews Carousel (mobile auto-advance) ──── */
  const reviewsGrid = document.querySelector('.reviews-grid');
  const reviewsTrack = document.querySelector('.reviews-grid__track');
  if (reviewsGrid && reviewsTrack) {
    const mq = window.matchMedia('(max-width: 768px)');
    const ADVANCE_MS = 3500;
    const RESUME_MS = 3000;
    let advanceTimer = null;
    let resumeTimer = null;

    const advance = function () {
      const card = reviewsGrid.querySelector('.review-card');
      if (!card) return;
      const step = card.getBoundingClientRect().width + 16; // matches CSS gap (1rem)
      const max = reviewsGrid.scrollWidth - reviewsGrid.clientWidth;
      if (reviewsGrid.scrollLeft >= max - 2) {
        reviewsGrid.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        reviewsGrid.scrollBy({ left: step, behavior: 'smooth' });
      }
    };

    const stop = function () {
      if (advanceTimer) { clearInterval(advanceTimer); advanceTimer = null; }
    };

    const start = function () {
      stop();
      if (!mq.matches) return;
      advanceTimer = setInterval(advance, ADVANCE_MS);
    };

    const onInteract = function () {
      stop();
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(start, RESUME_MS);
    };

    reviewsGrid.addEventListener('touchstart', onInteract, { passive: true });
    reviewsGrid.addEventListener('pointerdown', onInteract);
    reviewsGrid.addEventListener('wheel', onInteract, { passive: true });

    mq.addEventListener('change', function () {
      if (mq.matches) start();
      else stop();
    });
    start();
  }

  /* ── Results Chart: Animate Bars on Scroll ───── */
  const chart = document.querySelector('.results-chart');
  if (chart && 'IntersectionObserver' in window) {
    const obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          chart.classList.add('is-visible');
          obs.disconnect();
        }
      });
    }, { threshold: 0.25 });
    obs.observe(chart);
  } else if (chart) {
    chart.classList.add('is-visible');
  }

  /* ── Horizontal Scroll Indicators (generic) ──── */
  function wireScrollIndicator(trackSelector, thumbSelector) {
    const track = document.querySelector(trackSelector);
    const thumb = document.querySelector(thumbSelector);
    if (!track || !thumb) return;
    const update = function () {
      const max = track.scrollWidth - track.clientWidth;
      const progress = max > 0 ? track.scrollLeft / max : 0;
      thumb.style.transform = 'translateX(' + (progress * 200) + '%)';
    };
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  wireScrollIndicator('.ingredient-deck', '.ingredient-deck__indicator-thumb');
  wireScrollIndicator('.derm-cards__track', '.derm-cards__indicator-thumb');

  /* ── Ingredient Deck: prev/next arrow buttons ── */
  const deckPrev = document.querySelector('.ingredient-deck__nav--prev');
  const deckNext = document.querySelector('.ingredient-deck__nav--next');
  const deckEl = document.querySelector('.ingredient-deck');
  if (deckPrev && deckNext && deckEl) {
    const getStep = function () {
      const slide = deckEl.querySelector('.ingredient-deck__slide');
      if (!slide) return deckEl.clientWidth;
      return slide.getBoundingClientRect().width + 24; // ~1.5rem gap
    };
    deckPrev.addEventListener('click', function () {
      deckEl.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });
    deckNext.addEventListener('click', function () {
      deckEl.scrollBy({ left: getStep(), behavior: 'smooth' });
    });
  }

  /* ── Smooth Scroll for Anchor Links ───────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        var offset = 70; // nav height
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  /* ── CTAs: scroll to the featured-product buy box ──
     JSON-template sections render as shopify-section-template--<id>__<key>,
     and both the template id and the section key suffix are auto-generated,
     so match on the stable middle part. Falls back to page bottom if the
     section is gone. */
  document.querySelectorAll('[data-scroll="bottom"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var buyBox = document.querySelector('[id^="shopify-section-"][id*="featured_product_information"]');
      if (buyBox) {
        var offset = 70; // nav height
        var top = buyBox.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      } else {
        var max = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight
        );
        window.scrollTo({ top: max, behavior: 'smooth' });
      }
    });
  });

  /* ── Buy Module: Flavor Selector ──────────── */
  var flavors = document.querySelectorAll('.buy__flavor');
  flavors.forEach(function (btn) {
    btn.addEventListener('click', function () {
      flavors.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  /* ── Buy Module: Quantity Selector ────────── */
  var quantities = document.querySelectorAll('.buy__quantity');
  quantities.forEach(function (btn) {
    btn.addEventListener('click', function () {
      quantities.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      updatePrices();
    });
  });

  /* ── Buy Module: Purchase Type ────────────── */
  var purchaseTypes = document.querySelectorAll('.buy__purchase-type');
  purchaseTypes.forEach(function (label) {
    label.addEventListener('click', function () {
      purchaseTypes.forEach(function (l) { l.classList.remove('active'); });
      label.classList.add('active');
      label.querySelector('input').checked = true;
    });
  });

  /* ── Buy Module: Price Updates ────────────── */
  function updatePrices() {
    var activeQty = document.querySelector('.buy__quantity.active');
    if (!activeQty) return;
    var priceOne = activeQty.getAttribute('data-price-one');
    var priceSub = activeQty.getAttribute('data-price-sub');
    var qty = activeQty.getAttribute('data-qty');
    var period = qty === '30' ? '/month' : '';

    document.getElementById('sub-price').textContent = '$' + priceSub + period;
    document.getElementById('one-price').textContent = '$' + priceOne;
  }

  /* ── Buy Module: Image Thumbnails ─────────── */
  var thumbs = document.querySelectorAll('.buy__thumb');
  var heroImage = document.getElementById('buy-product-image');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      heroImage.src = thumb.getAttribute('data-full');
    });
  });

  /* ── Cross-Domain Query Parameter Passthrough ─
     When a visitor arrives from a Meta ad, the URL contains tracking
     params like ?fbclid=abc123. This snippet forwards those params to
     every drinksunpowder.com CTA link so Meta attribution isn't lost
     when the user crosses domains. Runs on DOMContentLoaded so all
     links are in the DOM before we patch them. */
  document.addEventListener('DOMContentLoaded', function () {
    var search = window.location.search;
    if (!search) return; // no params on this page — nothing to forward

    var links = document.querySelectorAll('a[href*="drinksunpowder.com"]');
    links.forEach(function (link) {
      var href = link.getAttribute('href');
      // Merge: if destination already has params use &, otherwise use ?
      var separator = href.indexOf('?') !== -1 ? '&' : '?';
      link.setAttribute('href', href + separator + search.slice(1));
    });
  });

})();
